var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPcHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 41,
    viewBox: "0 0 107 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3448_3552)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 102,
    height: 15,
    rx: 7.5,
    stroke: "#5C5A64",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 10H94V41L88.7905 34.4043L83.5809 41L78.6655 34.4043L73.75 41L68.7398 34.4043L63.7295 41L58.6148 34.4043L53.5 41L48.2905 34.4043L43.0809 41L38.1655 34.4043L33.25 41L28.2398 34.4043L23.2295 41L18.1148 34.4043L13 41V10Z",
    fill: "#949085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8H94V39L88.7905 32.4043L83.5809 39L78.6655 32.4043L73.75 39L68.7398 32.4043L63.7295 39L58.6148 32.4043L53.5 39L48.2905 32.4043L43.0809 39L38.1655 32.4043L33.25 39L28.2398 32.4043L23.2295 39L18.1148 32.4043L13 39V8Z",
    fill: "url(#paint0_linear_3448_3552)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6064 25V15.6689H37.7539V19.4629H33.8369V15.6689H31.9912V25H33.8369V21.001H37.7539V25H39.6064ZM41.4385 15.9492C41.4385 16.5098 41.9033 16.8926 42.457 16.8926C43.0176 16.8926 43.4756 16.5098 43.4756 15.9492C43.4756 15.3887 43.0176 14.999 42.457 14.999C41.9033 14.999 41.4385 15.3887 41.4385 15.9492ZM41.5615 25H43.3594V17.7471H41.5615V25ZM44.9795 19.9004C44.9795 21.2402 46.0322 21.7256 47.3379 21.999C48.2676 22.1836 49.1357 22.2861 49.1357 22.9902C49.1357 23.4619 48.7393 23.8652 47.8916 23.8652C47.1191 23.8652 46.6543 23.4961 46.5791 22.9629H44.8359C44.8359 24.2549 45.9229 25.1299 47.7891 25.1299C49.71 25.1299 50.8789 24.248 50.8789 22.7578C50.8789 21.418 49.9014 20.96 48.5684 20.7207C47.7412 20.5703 46.6953 20.4473 46.6953 19.7295C46.6953 19.1963 47.1465 18.8682 47.8506 18.8682C48.7256 18.8682 49.0195 19.374 49.0674 19.832H50.6602C50.6602 18.4854 49.6143 17.6172 47.8848 17.6172C46.3604 17.6172 44.9795 18.2871 44.9795 19.9004ZM52.793 17.7471H51.7334V19.1416H52.7588V22.9492C52.7588 24.4326 53.3535 25.041 55.1582 25.041C55.5205 25.041 55.8418 25.0068 55.9785 24.9795V23.6465C55.8965 23.6533 55.7461 23.6602 55.5957 23.6602C54.8506 23.6602 54.543 23.4414 54.543 22.7168V19.1416H55.9512V17.7471H54.543V16.0107H52.793V17.7471ZM60.4355 17.6172C58.2959 17.6172 57.1133 19.0869 57.1133 21.0898V21.623C57.1133 23.7285 58.2959 25.1299 60.4355 25.1299C62.5752 25.1299 63.751 23.7285 63.751 21.6162V21.083C63.751 19.0801 62.5684 17.6172 60.4355 17.6172ZM60.4355 19.0117C61.4746 19.0117 61.9326 19.9004 61.9326 21.083V21.6436C61.9326 22.792 61.4814 23.7285 60.4355 23.7285C59.3828 23.7285 58.9316 22.7852 58.9316 21.6436V21.083C58.9316 19.9072 59.3965 19.0117 60.4355 19.0117ZM65.2549 25H67.0938V20.8643C67.0938 19.8936 67.5039 19.1826 68.6865 19.1826C68.9668 19.1826 69.2539 19.2031 69.3975 19.2441V17.6855C69.2539 17.6582 69.0693 17.6377 68.8232 17.6377C67.832 17.6377 67.292 18.2803 67.1279 18.7451H67.0527V17.7471H65.2549V25ZM77.1631 17.7471H75.2559L73.6768 23.373H73.6084L72.0635 17.7471H70.0742L72.5898 25.0137L72.5215 25.2734C72.3916 25.9434 72.0156 26.21 71.1953 26.21C70.9766 26.21 70.7236 26.1895 70.6074 26.1689V27.4678C70.8262 27.5156 71.2158 27.543 71.5234 27.543C73.0957 27.543 73.9707 26.9619 74.5996 25.2939L74.7842 24.7949C74.7979 24.7539 76.6572 19.3877 77.1631 17.7471Z",
    fill: "#FE952F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3448_3552",
    x: 0,
    y: 0,
    width: 107,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3448_3552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3448_3552",
    x1: 53.5,
    y1: 8,
    x2: 52.853,
    y2: 40.9693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC7BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#FFF9E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FFF9E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcHistory);
export default __webpack_public_path__ + "static/media/pcHistory.6867fc0117bf3387ba90581157d09bf9.svg";
export { ForwardRef as ReactComponent };